var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$setPrefixes', '$debug', '$upcase', '$checkRoll', '$empty?', '$===', '$to_i', '$roll', '$sort', '$collect', '$split', '$+', '$getModifyText', '$join', '$getCriticalResult', '$nil?', '$isFumble', '$>=', '$==', '$<', '$size', '$select', '$to_s']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'StrangerOfSwordCity');

    var $nesting = [self].concat($parent_nesting), $StrangerOfSwordCity_initialize$1, $StrangerOfSwordCity_gameName$2, $StrangerOfSwordCity_gameType$3, $StrangerOfSwordCity_getHelpMessage$4, $StrangerOfSwordCity_rollDiceCommand$5, $StrangerOfSwordCity_checkRoll$6, $StrangerOfSwordCity_getModifyText$8, $StrangerOfSwordCity_getCriticalResult$9, $StrangerOfSwordCity_isFumble$11;

    
    self.$setPrefixes(["\\d+SR.*"]);
    
    Opal.def(self, '$initialize', $StrangerOfSwordCity_initialize$1 = function $$initialize() {
      var $iter = $StrangerOfSwordCity_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $StrangerOfSwordCity_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $StrangerOfSwordCity_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      self.sortType = 1;
      self.d66Type = 1;
      return (self.fractionType = "omit");
    }, $StrangerOfSwordCity_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $StrangerOfSwordCity_gameName$2 = function $$gameName() {
      var self = this;

      return "剣の街の異邦人TRPG"
    }, $StrangerOfSwordCity_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $StrangerOfSwordCity_gameType$3 = function $$gameType() {
      var self = this;

      return "StrangerOfSwordCity"
    }, $StrangerOfSwordCity_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $StrangerOfSwordCity_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this, info = nil;

      return (info = "" + "・判定　xSR or xSRy or xSR+y or xSR-y or xSR+y>=z\n" + "　x=ダイス数、y=修正値(省略可、±省略時は＋として扱う)、z=難易度(省略可)\n" + "　判定時はクリティカル、ファンブルの自動判定を行います。\n" + "・通常のnD6ではクリティカル、ファンブルの自動判定は行いません。\n" + "・D66ダイスあり\n")
    }, $StrangerOfSwordCity_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $StrangerOfSwordCity_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var self = this, result = nil;

      
      self.$debug("rollDiceCommand command", command);
      command = command.$upcase();
      result = "";
      result = self.$checkRoll(command);
      if ($truthy(result['$empty?']())) {
      } else {
        return result
      };
      return result;
    }, $StrangerOfSwordCity_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$checkRoll', $StrangerOfSwordCity_checkRoll$6 = function $$checkRoll(command) {
      var $a, $b, $$7, self = this, result = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, diceCount = nil, modify = nil, difficulty = nil, dice = nil, diceText = nil, diceList = nil, totalValue = nil, modifyText = nil, criticalResult = nil;

      
      self.$debug("checkRoll begin command", command);
      result = "";
      if ($truthy(/^(\d+)SR([\+\-]?\d+)?(>=(\d+))?$/i['$==='](command))) {
      } else {
        return result
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      diceCount = __last__match__1.$to_i();
      modify = __last__match__2.$to_i();
      if ($truthy(__last__match__4)) {
        difficulty = __last__match__4.$to_i()};
      $b = self.$roll(diceCount, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      diceList = $send(diceText.$split(/,/), 'collect', [], ($$7 = function(i){var self = $$7.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$to_i();}, $$7.$$s = self, $$7.$$arity = 1, $$7)).$sort();
      totalValue = $rb_plus(dice, modify);
      modifyText = self.$getModifyText(modify);
      result = $rb_plus(result, "" + "(" + (command) + ") ＞ " + (dice) + "[" + (diceList.$join(",")) + "]" + (modifyText) + " ＞ " + (totalValue));
      criticalResult = self.$getCriticalResult(diceList);
      if ($truthy(criticalResult['$nil?']())) {
      } else {
        
        result = $rb_plus(result, "" + " ＞ クリティカル(+" + (criticalResult) + "D6)");
        return result;
      };
      if ($truthy(self.$isFumble(diceList, diceCount))) {
        
        result = $rb_plus(result, " ＞ ファンブル");
        return result;};
      if ($truthy(difficulty['$nil?']())) {
      } else {
        result = $rb_plus(result, (function() {if ($truthy($rb_ge(totalValue, difficulty))) {
          return " ＞ 成功"
        } else {
          return " ＞ 失敗"
        }; return nil; })())
      };
      return result;
    }, $StrangerOfSwordCity_checkRoll$6.$$arity = 1);
    
    Opal.def(self, '$getModifyText', $StrangerOfSwordCity_getModifyText$8 = function $$getModifyText(modify) {
      var self = this;

      
      if ($truthy(modify['$=='](0))) {
        return ""};
      if ($truthy($rb_lt(modify, 0))) {
        return "" + (modify)};
      return "" + "+" + (modify);
    }, $StrangerOfSwordCity_getModifyText$8.$$arity = 1);
    
    Opal.def(self, '$getCriticalResult', $StrangerOfSwordCity_getCriticalResult$9 = function $$getCriticalResult(diceList) {
      var $$10, self = this, dice6Count = nil;

      
      dice6Count = $send(diceList, 'select', [], ($$10 = function(i){var self = $$10.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](6);}, $$10.$$s = self, $$10.$$arity = 1, $$10)).$size();
      if ($truthy($rb_ge(dice6Count, 2))) {
        return dice6Count.$to_s()};
      return nil;
    }, $StrangerOfSwordCity_getCriticalResult$9.$$arity = 1);
    return (Opal.def(self, '$isFumble', $StrangerOfSwordCity_isFumble$11 = function $$isFumble(diceList, diceCount) {
      var $$12, self = this;

      return $rb_ge($send(diceList, 'select', [], ($$12 = function(i){var self = $$12.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](1);}, $$12.$$s = self, $$12.$$arity = 1, $$12)).$size(), diceCount)
    }, $StrangerOfSwordCity_isFumble$11.$$arity = 2), nil) && 'isFumble';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
